export const LINE_ITEM_BUDGET_MIN = 1
export const LINE_ITEM_BUDGET_MAX = 1000000000
export const LINE_ITEM_BUDGET_STEP = 0.1
export const LINE_ITEM_BUDGET_PRECISION = 2

export const LINE_ITEM_BID_MIN = 0.02
export const LINE_ITEM_BID_MAX = 1000000000
export const LINE_ITEM_BID_STEP = 0.1
export const LINE_ITEM_BID_PRECISION = 2
